/**
 * Staff tags: point colleagues at a player's video or note so their phones get a push.
 * Org scoping is enforced server-side; a recipient outside the caller's organization refuses the
 * whole request.
 */

import { post } from "./api";
import type { NotifyStaffRequest, NotifyStaffResponse } from "../types/notify";

export const notifyStaff = async (
  prospectId: string,
  request: NotifyStaffRequest,
): Promise<NotifyStaffResponse> => {
  return post<NotifyStaffResponse>(
    `/api/prospects/${encodeURIComponent(prospectId)}/notify`,
    request,
  );
};
